"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPassword = exports.login = exports.fetchToken = void 0;
var _api = require("./api");
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* OPERATIONS = REDUX THUNKS
This file defines the public interface of the policy -- what can be dispatched from components
*/

var AUTHENTICATION_FAILED = 'Login failed';
var login = exports.login = function login(username, password) {
  return function (dispatch) {
    // reset the error
    dispatch(actions.token({
      error: undefined
    }));
    (0, _api.userLogin)(username, password).then(function (response) {
      actions.login(response);
      dispatch(actions.login(response));
      var sessionToken = response.sessionToken;
      //console.log(sessionToken);
      dispatch(authorize(sessionToken));
    }).catch(function (error) {
      dispatch(actions.token({
        error: AUTHENTICATION_FAILED
      }));
    });
  };
};
var authorize = function authorize(sessionToken) {
  return function (dispatch) {
    (0, _api.getAuthorization)(sessionToken).then(function (responseOutput) {
      var authCode = responseOutput.authCode;
      var sid = responseOutput.sid;
      //console.log(`authCode: ${authCode}`);
      //console.log(`sid: ${sid}`);
      // get the token to use for api calls
      //dispatch(actions.token({ error: 'fetch api call execution error. check log for more info' }));
      //dispatch(fetchToken(authCode));
      dispatch(actions.token({
        status: 'authorized',
        authentication_token: authCode
      }));
      dispatch(actions.sid({
        id: sid
      }));
      //return response;
    }).catch(function (error) {
      dispatch(actions.token({
        error: AUTHENTICATION_FAILED
      }));
    });
  };
};
var fetchToken = exports.fetchToken = function fetchToken(authCode) {
  return function (dispatch) {
    (0, _api.getToken)(authCode).then(function (response) {
      dispatch(actions.token(response));
    }).catch(function () {
      dispatch(actions.token({
        error: AUTHENTICATION_FAILED
      }));
    });
  };
};
var resetPassword = exports.resetPassword = function resetPassword(emailAddress) {
  return function (dispatch) {
    return dispatch(actions.forgotPw(emailAddress));
  };
};